import { useCallback, useMemo } from 'react';
import { Row } from 'react-table';
import { Button, Table } from '@nbirl/nbi-common-ui-libs';

import { useBulkUploads } from '../../../../shared/context';
import {
  BulkUploadActionType,
  UploadRejectionCode,
} from '../../../../shared/enum';
import { useQueryParams } from '../../../../shared/hooks';
import { TableQueryState, UploadType } from '../../../../shared/models';
import { isRejectedUpload } from '../../../../shared/utils';
import { getUploadListColumns } from '../constants';

export const UploadingSection = () => {
  const [tableState] = useQueryParams<TableQueryState>({
    pageSize: 50,
    pageIndex: 0,
    sortBy: '',
  });
  const {
    dispatch,
    state: { uploading, rejected },
  } = useBulkUploads();

  const renderActionsColumn = useCallback(
    ({ row }: { row: Row<UploadType> }) => {
      if (isRejectedUpload(row.original)) {
        return (
          <div className="flex justify-end space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                dispatch({
                  type: BulkUploadActionType.REMOVE_UPLOAD,
                  payload: { id: row.original.id, collection: 'rejected' },
                })
              }
            >
              Remove
            </Button>
            {row.original.error.code !== UploadRejectionCode.FILE_TOO_LARGE && (
              <Button
                variant="outline"
                size="sm"
                onClick={() =>
                  dispatch({
                    type: BulkUploadActionType.MOVE_REJECTED_TO_QUEUED,
                    payload: { id: row.original.id },
                  })
                }
              >
                Retry
              </Button>
            )}
          </div>
        );
      }
      return <></>;
    },
    [dispatch]
  );

  const columns = useMemo(
    () => getUploadListColumns(renderActionsColumn),
    [renderActionsColumn]
  );

  return (
    <div className="mb-6" data-testid="uploading-section">
      <h4 className="font-medium mb-4">Uploading</h4>

      <Table
        columns={columns}
        data={[...uploading, ...rejected]}
        disableSortRemove
        hasRowDividers
        showPagination={true}
        totalCount={uploading.length + rejected.length}
        {...tableState}
      />
    </div>
  );
};
